import { isEmpty } from 'lodash';

const weekDayToIndexMapping = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const createDateOnThisWeek = (weekDay, time) => {
  const date = new Date();
  const timeArr = time.split(':');
  // create a date object that is the weekday (given as parameter) of the current week
  const result = new Date(date.setDate(date.getDate() - date.getDay() + weekDayToIndexMapping[weekDay]));
  result.setHours(timeArr[0]);
  result.setMinutes(timeArr[1]);
  return result;
};

/*
 * Check whether current weekday/hours/minutes is inside the schedule
 */
const isKioskAvailable = kiosk => {
  if (isEmpty(kiosk?.schedule)) {
    return true;
  }

  const date = new Date();

  return kiosk?.schedule.some(timerange => {
    const startDate = createDateOnThisWeek(
      timerange.dayOfWeek,
      timerange.startTime,
    );
    const endDate = createDateOnThisWeek(
      timerange.dayOfWeek,
      timerange.endTime,
    );

    return startDate <= date && date < endDate;
  });
};

const hasAvailabilityTimes = kiosk => !isEmpty(kiosk?.schedule);

/*
 * Check whether product should be disabled
 */
const invalidProduct = product => !product?.sellable;

/*
 * Get kiosk products that are currently visible
 */
const getVisibleProducts = kiosk => kiosk?.kioskProducts?.filter(product => product.visible) ?? [];

export default {
  isKioskAvailable,
  hasAvailabilityTimes,
  invalidProduct,
  getVisibleProducts,
};
